import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { IProjectCheckpointArtifact } from '../../projectCheckpoints.types'
import NumberInput from 'shared/Inputs/NumberInput'
import Textarea from 'shared/Inputs/Textarea'
import { PropsWithChildren } from 'react'
import ToggleWithLabel from 'shared/Inputs/Toggle/ToggleWithLabel'
import Select from 'shared/Inputs/Select'

interface IProps {
  artifact: Omit<IProjectCheckpointArtifact, 'id'>
  onChange: (val: any, name: string) => void
}

const TYPE_OPTIONS: { label: string; value: IProjectCheckpointArtifact['type'] }[] = [
  { label: 'Текст', value: 'TEXT' },
  { label: 'Файл', value: 'FILE' },
]

const ArtifactSheet = (props: PropsWithChildren<IProps>) => {
  return (
    <Sheet>
      <div className='flex-lines'>
        <div className='flex-space-between'>
          <div>Артефакт</div>
          <ToggleWithLabel checked={props.artifact.required} name='required' onChange={props.onChange}>
            Обязательный
          </ToggleWithLabel>
        </div>
        <TextField header='Тип'>
        <Select
          options={TYPE_OPTIONS}
          onChange={props.onChange}
          selectedOption={TYPE_OPTIONS.find((o) => o.value === props.artifact.type)}
          name='type'
        />
        </TextField>
        <TextField header='Вопрос'>
          <TextInput
            value={props.artifact.title}
            onChange={props.onChange}
            name='title'
            placeholder='Чему равно число Pi'
          />
        </TextField>
        {props.artifact.type === 'TEXT' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '1em', justifyContent: 'space-between' }}>
            <TextField header='Кол-во символов: мин.' style={{ flex: 0.5 }}>
              <NumberInput value={props.artifact.minSymbols} onChange={props.onChange} name='minSymbols' />
            </TextField>
            <TextField header='макс.' style={{ flex: 0.5 }}>
              <NumberInput value={props.artifact.maxSymbols} onChange={props.onChange} name='maxSymbols' />
            </TextField>
          </div>
        )}
        <TextField header='Пояснение'>
          <Textarea
            value={props.artifact.description}
            onChange={props.onChange}
            name='description'
            placeholder='Укажите число Pi с точностью до трех знаков после запятой'
            required={false}
          />
        </TextField>
      </div>
      <div>{props.children}</div>
    </Sheet>
  )
}

export default ArtifactSheet
